import React from 'react'
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import { Provider, TableView, TableHeader, Column, Row, TableBody, Cell } from '@adobe/react-spectrum'
import { customSpectrumTheme, SPECTRUM_THEME_CLASS } from '../../themes/spectrum-theme'
import Title from '../ui/title'
import Content from '../ui/content'
import Breadcrumbs from '../ui/breadcrumbs'
import styles from './styles'

class TermsAcceptanceLogsView extends React.Component {
  formatDate = (dateString) => {
    if (!dateString) return '-'
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB')
  }

  formatCurrency = (pence) => {
    if (!pence && pence !== 0) return '£0.00'
    return `£${(pence / 100).toFixed(2)}`
  }

  renderTable = () => {
    const { termsAcceptanceLogs, classes, translate } = this.props
    const data = termsAcceptanceLogs?.data

    if (!Array.isArray(data) || data.length === 0) {
      return (
        <div style={{ padding: '24px', textAlign: 'center' }}>
          <Typography>{translate("no_data_found") || "No terms acceptance logs found"}</Typography>
        </div>
      )
    }

    return (
      <div>
        <TableView aria-label="Terms acceptance logs">
          <TableHeader>
            <Column>{translate("general_date")}</Column>
            <Column>{translate("accepted_by") || "Accepted By"}</Column>
            <Column>{translate("amount") || "Amount"}</Column>
            <Column>{translate("status")}</Column>
            <Column>{translate("ip_address") || "IP Address"}</Column>
            <Column>{translate("terms_version") || "Terms Version"}</Column>
          </TableHeader>
          <TableBody>
            {data.map((log) => (
              <Row key={log.id}>
                <Cell>{this.formatDate(log.AcceptedAt)}</Cell>
                <Cell>{log.AcceptedBy || '-'}</Cell>
                <Cell>{this.formatCurrency(log.AmountInPence)}</Cell>
                <Cell>
                  <span style={{
                    backgroundColor: '#e8f5e9',
                    color: '#4caf50',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px'
                  }}>
                    Accepted
                  </span>
                </Cell>
                <Cell style={{ fontSize: '12px', color: '#666' }}>{log.IpAddress || '-'}</Cell>
                <Cell>{log.TermsVersion || '-'}</Cell>
              </Row>
            ))}
          </TableBody>
        </TableView>
      </div>
    )
  }

  renderPagination = () => {
    const { termsAcceptanceLogs, classes, onPageChange, currentPage, translate } = this.props
    const pagination = termsAcceptanceLogs?.pagination

    if (!pagination || pagination.totalPages <= 1) {
      return null
    }

    return (
      <div className={classes.paginationContainer}>
        <button
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className={classes.paginationButton}
        >
          {translate("general_table_previous")}
        </button>
        <span style={{ margin: '0 8px' }}>
          {translate("general_table_page")} {currentPage} {translate("general_table_of")} {pagination.totalPages}
        </span>
        <button
          disabled={currentPage === pagination.totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className={classes.paginationButton}
        >
          {translate("general_table_next")}
        </button>
      </div>
    )
  }

  render() {
    const { classes, translate } = this.props

    const breadcrumbItems = [
      { label: translate("dashboard_title") || "Dashboard", link: '/dashboard' },
      { label: translate("terms_acceptance_logs") || "Terms Acceptance Logs" }
    ]

    return (
      <Provider theme={customSpectrumTheme} UNSAFE_className={SPECTRUM_THEME_CLASS} colorScheme="light">
        <div>
          <Title
            title={translate("terms_acceptance_logs") || "Terms Acceptance Logs"}
            back={
              <Breadcrumbs items={breadcrumbItems} />
            }
          />
          <Content translate={translate}>
            <div className={classes.container} style={{ paddingTop: '100px' }}>
              <div className={classes.tableSection}>
                <div className={classes.tableHeader}>
                  <h3 style={{ margin: '0 0 16px 0' }}>
                    {translate("terms_acceptance_logs") || "Terms Acceptance Logs"}
                  </h3>
                </div>

                {this.renderTable()}
                {this.renderPagination()}
              </div>
            </div>
          </Content>
        </div>
      </Provider>
    )
  }
}

export default withStyles(styles)(TermsAcceptanceLogsView)
